export default "__VITE_ASSET__ChqMpUx7__"